module.exports = __webpack_public_path__ + "media/mypage/images/guys-background-150x150-ebdd3a704e1a4a4b54c1e74613c121c8.jpg";